import { v4 as uuidv4 } from 'uuid'

export const budgetHolders = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Budget Holder Code ' + ++index,
  __typename: 'BudgetHolder'
}))
